import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { MRT_ColumnDef } from "material-react-table";
import type { AuditLogEntry } from "src/api/client-api/auditLog/auditLogSchemas";
import { ActorBadge } from "./ActorBadge";
import { AuditLogIpLabel, AuditLogScopeLabel } from "./AuditLogCells";
import { AuditLogObjectLabel } from "./AuditLogObjectLabel";
import { AuditLogTimestamp } from "./AuditLogTimestamp";

export const useAuditLogColumns = (): MRT_ColumnDef<AuditLogEntry, any>[] => {
    const { t } = useTranslation();

    return useMemo(
        () => [
            {
                accessorKey: "occurredAt",
                header: t("settings.audit_log.column.occurred_at_utc", "Time (UTC)"),
                size: 196,
                Cell: ({ row }) => <AuditLogTimestamp occurredAt={row.original.occurredAt} />,
            },
            {
                accessorKey: "actorLabel",
                header: t("settings.audit_log.column.actor", "Actor"),
                size: 176,
                Cell: ({ row }) => <ActorBadge entry={row.original} />,
            },
            {
                accessorKey: "entityLabel",
                header: t("settings.audit_log.column.affected_object", "Affected object"),
                size: 420,
                Cell: ({ row }) => <AuditLogObjectLabel entry={row.original} />,
            },
            {
                accessorKey: "rootLabel",
                header: t("settings.audit_log.column.scope", "Scope"),
                size: 160,
                Cell: ({ row }) => <AuditLogScopeLabel entry={row.original} />,
            },
            {
                accessorKey: "ip",
                header: t("settings.audit_log.column.ip", "IP"),
                size: 128,
                Cell: ({ row }) => <AuditLogIpLabel entry={row.original} />,
            },
        ],
        [t],
    );
};
